<template>
  <div class="poll-bubble">
    <div class="poll-question">
      {{ question }}
    </div>
    <ul class="poll-options">
      <li v-for="(option, index) in options" :key="index" class="poll-option">
        <span class="poll-bullet" />
        <span class="poll-option-text">{{ option }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BubblePoll',
  props: {
    question: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.poll-bubble {
  padding: 0 0 8px 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
}

.poll-question {
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-default);
  line-height: var(--space-medium);
  word-wrap: break-word;
  padding-bottom: 8px;
}

.poll-options {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.poll-option {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  line-height: var(--space-two);
  color: #27282b;
  padding: 2px 8px;
}

.poll-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #27282b;
  flex-shrink: 0;
  margin-top: 7px;
  margin-left: 4px;
  margin-right: 4px;
  opacity: 0.6;
}

.poll-option-text {
  flex: 1;
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>
